import './App.css';
import Position from "./components/Position";

function App() {
  return (
      <Position />
  );
}

export default App;
